module.exports = __webpack_public_path__ + "static/media/p208g4.e3cb90c8.jpg";